<div class="flex flex-col items-center py-6 max-w-[350px]">
  <span data-test-id="title" class="font-bold text-grey-900 text-base text-center my-3">
    You cannot login at this time due to multiple incorrect attempts. Please try again later.
  </span>
  <span data-test-id="content" class="font-normal text-grey-600 text-base text-center"
    >After 15 minutes, please try again or reset your PIN.
  </span>
</div>
